const EVENT_ACTION_BASE = 'recommended.property';
const EVENT_ACTION_CLICK_BASE = `${EVENT_ACTION_BASE}.click`;
const getEventAction = (eventaction) => ({eventaction});

const EVENT_ACTION_DESTINATION = 'destination';
const EVENT_ACTION_LINK = `${EVENT_ACTION_DESTINATION}.link`;

export const EVENT = 'generic.event';
export const EVENT_CATEGORY = {eventcategory: 'recommendation'};

export const EVENT_ACTIONS = {
    DESTINATION_CARD_CLICK: getEventAction(`${EVENT_ACTION_LINK}.click`),
    CAROUSEL_VIEW: getEventAction('recommended.carousel.view'),
    CARD_VIEW: getEventAction(`${EVENT_ACTION_BASE}.view`),
    CLICK: getEventAction(`${EVENT_ACTION_CLICK_BASE}`),
    CONTEXT_MENU: getEventAction(`${EVENT_ACTION_CLICK_BASE}.contextmenu`),
    NEXT_CLICK: getEventAction(`${EVENT_ACTION_CLICK_BASE}.next`),
    PREV_CLICK: getEventAction(`${EVENT_ACTION_CLICK_BASE}.prev`),
    SEE_MORE_BUTTON_CLICK: getEventAction(
        'see.more.recommendations.button.click'
    ),
    SEE_MORE_CARD_CLICK: getEventAction('see.more.recommendations.card.click'),
};
